module.exports = __webpack_public_path__ + "img/L_8H.9e1e9d54.png";